import { DATA, C, FONT_HEAD, FONT_MONO } from "../data";

function SectionLabel({ num, title }) {
  return (
    <div style={{ marginBottom: "1rem", paddingLeft: "clamp(0px, 15vw, 4.5rem)" }}>
      <div style={{ fontFamily: FONT_MONO, fontSize: "0.72rem", color: C.accentBorder, letterSpacing: "4px", marginBottom: "0.6rem" }}>
        {num + " ───────────"}
      </div>
      <h2 style={{ fontFamily: FONT_HEAD, fontWeight: 800, fontSize: "clamp(1.3rem,4vw,2.6rem)", color: "#fff" }}>
        {title}
      </h2>
    </div>
  );
}

export default function Skills() {
  return (
    <div className="anim-fadeup" style={{ padding: "4rem clamp(1.5rem,5vw,4rem)", maxWidth: "900px", margin: "0 auto" }}>
      <SectionLabel num="02" title="Skills & Technologies" />

      <div style={{ height: "1px", background: `linear-gradient(90deg, ${C.accentBorder}, transparent)`, marginBottom: "3rem", marginLeft: "clamp(0px, 15vw, 4.5rem)" }} />

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))", gap: "1.25rem" }}>
        {DATA.skills.map(cat => (
          <div key={cat.category} className="card-lift" style={{
            background: C.card, border: `1px solid ${C.cardBorder}`,
            borderRadius: "10px", padding: "1.6rem",
          }}>
            <div style={{ fontSize: "1.6rem", marginBottom: "0.8rem" }}>{cat.icon}</div>
            <div style={{ fontFamily: FONT_MONO, fontSize: "0.68rem", color: C.accent, letterSpacing: "2px", marginBottom: "1.2rem", fontWeight: 600 }}>
              {cat.category.toUpperCase()}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "0.45rem" }}>
              {cat.items.map(skill => (
                <div key={skill} className="skill-chip" style={{
                  background: "rgba(255,255,255,0.03)", color: C.text,
                  border: `1px solid ${C.cardBorder}`, padding: "0.45rem 0.8rem",
                  borderRadius: "4px", fontSize: "0.8rem", fontFamily: FONT_MONO, cursor: "default",
                }}>
                  {skill}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
